import { OccurrenceCounter } from '@/domain/termine/components';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import { Field } from '@e2n/ui';

export function OccurrenceCountFormField({
  className,
  form,
}: UpdateTermineFormProps) {
  return (
    <form.Field name="occurrenceCount">
      {(field) => (
        <Field className="flex flex-row w-1/3 gap-1">
          <div className={className}>
            <OccurrenceCounter
              value={field.state.value ?? 1}
              onChange={field.handleChange}
            />
          </div>
        </Field>
      )}
    </form.Field>
  );
}
